// AutosizeTextarea.js
import React, { forwardRef, useLayoutEffect, useRef } from 'react';
import { Textarea } from '@chakra-ui/react';

const AutosizeTextarea = forwardRef((props, ref) => {
    const internalRef = useRef(null);
    const textRef = ref || internalRef;

    // adjust height on every render/value change
    useLayoutEffect(() => {
        const el = textRef.current;
        if (el) {
            el.style.height = 'auto';
            el.style.height = el.scrollHeight + 'px';
        }
    }, [props.value, textRef]);

    // wrap change to trigger both autosize + user onChange
    const handleChange = (e) => {
        const el = textRef.current;
        if (el) {
            el.style.height = 'auto';
            el.style.height = el.scrollHeight + 'px';
        }
        props.onChange?.(e);
    };

    return (
        <Textarea
            {...props}
            ref={textRef}
            onChange={handleChange}
            resize="none"
            overflow="hidden"
            minH="2rem"
            maxH="10rem"
            variant="unstyled"
        />
    );
});

export default AutosizeTextarea;
